export const LOCALSTORAGE_TOKEN = "daemon-crm-token";
export const LOCALSTORAGE_THEME = "daemon-crm-theme";
